import React, { useImperativeHandle, useRef } from "react";

export interface TextFieldProps {
  id?: string;
  name: string;
  icon?: string;
  label?: string;
  validations?: any;
  placeholder?: string;
  type?: string;
  autoComplete?: string;
  showLabel?: boolean;
  required?: boolean;
  onChange?: Function;
  error?: boolean;
  errorText?: String;
  autoFocus?: boolean;
  maxWidth?: string;
}

type NativeAttrs = Omit<React.InputHTMLAttributes<any>, keyof TextFieldProps>;
export type InputProps = TextFieldProps & NativeAttrs;

const TextField = React.forwardRef<
  HTMLInputElement,
  React.PropsWithChildren<InputProps>
>(
  (
    {
      id,
      name,
      icon,
      label,
      type,
      validations,
      autoComplete,
      placeholder,
      showLabel,
      required,
      onChange,
      error,
      errorText,
      autoFocus,
      maxWidth,
    },
    ref: React.Ref<HTMLInputElement | null>
  ) => {
    let isDate = validations?.isDate;
    const inputRef = useRef<HTMLInputElement>(null);
    useImperativeHandle(ref, () => inputRef.current);

    return (
      <div className="text-left w-full" style={maxWidth ? { maxWidth } : {}}>
        <div
          className={`text-sm mb-2 ${!label || !showLabel ? "hidden" : null}`}
        >
          <label
            id={[name, "label"].join("-")}
            htmlFor={[name, "input"].join("-")}
          >
            {label}
          </label>
        </div>
        <div className={`text-left rounded-text-field h-12 relative`}>
          {icon ? (
            <div className="absolute" style={{ left: "20px", top: "16px" }}>
              <img src={icon} className="h-4" />
            </div>
          ) : null}
          <input
            ref={inputRef}
            className={`h-full w-full bg-white rounded-text-field ${
              icon ? "pl-12" : "pl-4"
            } pr-8 border ${
              error ? "border-red-500" : "border-gray-200"
            }  focus:outline-none ${
              error ? "focus:border-red-500" : "focus:border-black"
            }`}
            autoComplete={autoComplete}
            id={[id || name, "input"].join("-")}
            name={name}
            placeholder={placeholder}
            required={required}
            type={type}
            autoFocus={autoFocus}
            onChange={
              onChange ? (e) => onChange(e.target.value, id) : () => null
            }
          />
        </div>
        {error ? (
          <p className="mt-1 text-xs text-red-500">{errorText}</p>
        ) : null}
      </div>
    );
  }
);
TextField.defaultProps = {
  showLabel: true,
};
export default TextField;
